import {Component} from '@angular/core'
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone'
import {Dialogistic} from '../../../../craft/dialog/dialogistic.interface'
import {Observable, Subject} from 'rxjs'

@Component({
  selector: 'bgo-calculator-close-confirmation',
  templateUrl: './calculator-close-confirmation.component.html',
})
export class CalculatorCloseConfirmationComponent implements Dialogistic<string, boolean> {
  readonly phoneIcon = faPhone
  exitButtonText!: string
  readonly confirm: Subject<boolean> = new Subject<boolean>()

  close(): void {
    this.confirm.next(true)
  }

  setData(exitButtonText: string): void {
    this.exitButtonText = exitButtonText
  }

  reply$(): Observable<boolean> {
    return this.confirm.asObservable()
  }
}
